export default {
  system: {
    name: 'Система управления',
    language: 'Язык',
    theme: 'Тема оформления'
  },
  auth: {
    login: 'Вход в систему',
    adminPanel: 'Панель администратора',
    phone: 'Номер телефона',
    password: 'Пароль',
    signIn: 'Войти',
    logout: 'Выйти',
    confirmLogout: 'Подтверждение выхода',
    confirmLogoutText: 'Вы действительно хотите выйти из системы?',
    loginError: 'Ошибка входа. Проверьте email и пароль.',
    forgotPassword: 'Если вы не знаете как войти или забыли пароль,',
    contactSupport: 'обратитесь в компанию Lockerbot по email:'
  },
  dashboard: {
    title: 'Панель управления',
    user: 'Пользователь',
    goodMorning: 'Доброе утро',
    goodAfternoon: 'Добрый день',
    goodEvening: 'Добрый вечер',
    welcomeMessage: 'Добро пожаловать в панель управления LockerBot. Здесь вы можете управлять посылками, пользователями и настройками.',
    profile: 'Мой профиль',
    profileTitle: 'Профиль пользователя',
    viewAllActive: 'Показать все активные',
    viewAllExpired: 'Просмотреть все просроченные посылки',
    viewAllFinished: 'Просмотреть все завершенные посылки',
    totalUsers: 'Всего пользователей',
    totalPackages: 'Всего посылок',
    activePackages: 'Активных посылок',
    deliveredToday: 'Доставлено сегодня',
    totalCells: 'Всего ячеек',
    cellsUsage: 'Занято ячеек',
    averageDailyUsage: 'Средняя загрузка',
    cellsUsageChart: 'График заполняемости ячеек',
    recentPackages: 'Последние посылки',
    activeUsers: 'Активные пользователи',
    lastActive: 'Последняя активность',
    lockedPackages: 'Активные посылки',
    expiredPackages: 'Просроченные',
    finishedPackages: 'Завершённые',
    currentlyStored: 'Сейчас на хранении',
    storageExpired: 'Срок хранения истёк',
    successfullyDelivered: 'Успешно доставлены',
    users: 'Пользователей',
    occupancyChart: 'История занятости ячеек',
    periodSelector: {
      last30Days: 'Последние 30 дней',
      last60Days: 'Последние 60 дней',
      last90Days: 'Последние 90 дней'
    },
    cellsStatus: 'Статус ячеек',
    activeCells: 'Активные',
    brokenCells: 'Сломанные',
    occupiedCells: 'Занятые',
    reservedCells: 'Зарезервированные',
    occupancy: 'Заполненность ячеек',
    occupancyDescription: 'Текущая статистика использования ячеек',
    usageHistory: 'История использования',
    usageHistoryDescription: 'Активность посылок за период',
    period: 'Период',
    days7: '7 дней',
    days30: '30 дней',
    days90: '90 дней',
    lockersStatus: 'Статус ячеек',
    totalLockers: 'Всего ячеек',
    onlineLockers: 'В сети',
    offlineLockers: 'Не в сети',
    maintenanceLockers: 'На обслуживании',
    errorLockers: 'С ошибкой'
  },
  menu: {
    users: 'Пользователи',
    packages: 'Посылки',
    settings: 'Настройки'
  },
  users: {
    title: 'Пользователи',
    add: 'Добавить',
    confirmDelete: 'Подтверждение удаления',
    confirmDeleteText: 'Вы действительно хотите удалить этого пользователя?',
    createSuccess: 'Пользователь успешно создан',
    createError: 'Ошибка при создании пользователя',
    phoneExists: 'Пользователь с таким номером телефона уже существует',
    deleteSuccess: 'Пользователь успешно удален',
    deleteError: 'Ошибка при удалении пользователя',
    communities: 'Сообщества',
    search: 'Поиск по имени',
    communityFilter: 'Фильтр по сообществу',
    statusFilter: 'Фильтр по статусу',
    createTitle: 'Создание пользователя',
    editTitle: 'Редактирование пользователя',
    email: 'Email',
    phone: 'Телефон',
    fullName: 'ФИО',
    firstName: 'Имя',
    lastName: 'Фамилия',
    password: 'Пароль',
    passwordHint: 'Оставьте пустым, чтобы не менять',
    role: 'Роль',
    status: 'Статус',
    coinBalance: 'Баланс монет',
    isActive: 'Активный пользователь',
    dateJoined: 'Дата регистрации',
    actions: 'Действия',
    edit: 'Редактировать',
    delete: 'Удалить',
    statuses: {
      active: 'Активен',
      inactive: 'Неактивен'
    },
    topupBalance: 'Пополнить баланс',
    topupFor: 'Пополнить баланс для',
    coinsAmount: 'Количество монет',
    topupSuccess: 'Баланс успешно пополнен',
    topupError: 'Ошибка при пополнении баланса'
  },
  packages: {
    title: 'Посылки',
    add: 'Добавить',
    sender: 'Отправитель',
    recipient: 'Получатель',
    type: 'Тип',
    status: 'Статус',
    details: 'Подробнее',
    detailsTitle: 'Информация о посылке',
    statusFilter: 'Фильтр по статусу',
    typeFilter: 'Фильтр по типу',
    search: 'Поиск',
    id: 'ID',
    device: 'Устройство',
    cell: 'Ячейка',
    createdAt: 'Создано',
    expiresAt: 'Срок действия до',
    price: 'Цена',
    courier: 'Курьер',
    basicInfo: 'Основная информация',
    contactInfo: 'Контактная информация',
    locationInfo: 'Информация о местоположении',
    phone: 'Телефон',
    community: 'Сообщество',
    notFound: 'Посылка не найдена',
    notFoundText: 'Посылка, которую вы ищете, не существует или была удалена.',
    backToList: 'Вернуться к списку посылок',
    eventsHistory: 'История событий',
    eventTypes: {
      cell_was_opened: 'Ячейка открыта',
      cell_was_closed: 'Ячейка закрыта',
      parcel_created: 'Посылка создана',
      parcel_updated: 'Посылка обновлена',
      parcel_expired: 'Срок действия посылки истек',
      parcel_finished: 'Посылка завершена',
      parcel_canceled: 'Посылка отменена',
      cell_photo_was_received: 'Фото'
    },
    statuses: {
      all: 'Все статусы',
      new: 'Новая',
      locked: 'Заблокирована',
      finished: 'Завершена',
      canceled: 'Отменена',
      expired: 'Просрочена'
    },
    types: {
      delivery: 'Доставка',
      storage: 'Хранение',
      shared: 'Общий доступ'
    },
    dateFilter: 'Фильтр по дате создания',
    startDateFilter: 'С даты',
    endDateFilter: 'По дату'
  },
  settings: {
    title: 'Настройки',
    profileInfo: 'Информация профиля',
    appSettings: 'Настройки приложения',
    email: 'Email',
    fullName: 'ФИО',
    notSpecified: 'Не указано',
    role: 'Роль',
    language: 'Язык системы',
    dateJoined: 'Дата регистрации',
    theme: 'Тема оформления',
    roles: {
      administrator: 'Администратор',
      manager: 'Менеджер',
      customer: 'Клиент'
    },
    notifications: {
      email: 'Email уведомления',
      sms: 'SMS уведомления'
    },
    save: 'Сохранить настройки',
    communities: 'Сообщества',
    communitySettings: 'Настройки сообщества',
    confirmSaveTitle: 'Подтверждение изменений',
    confirmSaveText: 'Вы действительно хотите сохранить внесенные изменения?',
    noCommunities: 'У вас нет доступных сообществ',
    selectCommunity: 'Выберите сообщество',
    generalSection: 'Общие настройки',
    limitsSection: 'Настройки лимитов',
    pricingSection: 'Настройки стоимости',
    communityName: 'Название сообщества',
    communityAddress: 'Адрес',
    autoApproveUsers: 'Автоматическое добавление пользователей',
    maxCellsPerCustomer: 'Максимальное количество ячеек',
    maxCellsPerCustomerHint: 'Максимальное количество ячеек на одного пользователя',
    maxDeliveryHours: 'Максимальное время доставки',
    maxDeliveryHoursHint: 'Максимальное количество часов хранения доставки',
    maxStorageHours: 'Максимальное время хранения',
    maxStorageHoursHint: 'Максимальное количество часов аренды ячейки',
    minStorageHours: 'Минимальное время хранения',
    minStorageHoursHint: 'Минимальное количество часов аренды ячейки',
    maxSharingHours: 'Максимальное время шеринга',
    maxSharingHoursHint: 'Максимальное количество часов для шеринга ячейки',
    deliveryHourlyPrice: 'Стоимость часа доставки',
    deliveryHourlyPriceHint: 'Цена за час хранения доставки',
    storageHourlyPrice: 'Стоимость часа хранения',
    storageHourlyPriceHint: 'Цена за час аренды ячейки',
    sharingHourlyPrice: 'Стоимость часа шеринга',
    sharingHourlyPriceHint: 'Цена за час шеринга ячейки',
    freeDeliveryHours: 'Бесплатные часы доставки',
    freeDeliveryHoursHint: 'Количество бесплатных часов хранения входящих посылок',
    freeStorageHours: 'Бесплатные часы хранения',
    freeStorageHoursHint: 'Количество бесплатных часов хранения',
    freeSharingHours: 'Бесплатные часы шеринга',
    freeSharingHoursHint: 'Количество бесплатных часов шеринга',
    priceBySlot: 'Цена за слот',
    priceBySlotHint: 'Цена указывается за каждый слот отдельно'
  },
  common: {
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    create: 'Создать',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    filter: 'Фильтр',
    reset: 'Сбросить',
    loading: 'Загрузка...',
    noData: 'Нет данных',
    unknownUser: 'Неизвестный пользователь',
    copied: '{field} скопирован в буфер обмена',
    copyError: 'Не удалось скопировать в буфер обмена',
    close: 'Закрыть',
    error: 'Ошибка',
    success: 'Успешно',
    warning: 'Предупреждение',
    info: 'Информация',
    ok: 'ОК',
    pagination: {
      showing: "Показано",
      of: "из",
      perPage: "на странице"
    }
  },
  validation: {
    required: 'Обязательное поле',
    phone: 'Введите номер в международном формате',
    minLength: 'Минимальная длина: {min} символов',
    maxLength: 'Максимальная длина: {max} символов',
    minValue: 'Минимальное значение: {min}',
    maxValue: 'Максимальное значение: {max}'
  },
  locker: {
    title: 'Community Locker',
    slogan: 'Легко отправляйте, забирайте или делитесь посылками с вашим сообществом. Никаких очередей, никаких хлопот — простая и безопасная доставка всегда под рукой.',
    downloadTitle: 'Скачайте наше приложение',
    appStore: 'Скачать в App Store',
    googlePlay: 'Получить в Google Play',
    copyright: '© 2025. Все права защищены.'
  },
  pickup: {
    title: 'Получение посылки',
    description: 'Отсканируйте QR-код ниже, чтобы получить вашу посылку из ячейки.',
    code: 'Код посылки',
    qrCodeAlt: 'QR-код для получения посылки',
    generating: 'Генерация QR-кода...',
    download: 'Скачать QR-код'
  }
} 